import 'isomorphic-fetch';


export function getJSON(url, callback){
    return resolve => 
        fetch(url, {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(json => {
            if (typeof callback === 'function'){
                callback(json);
            }
            resolve(json);
        })
}